import { useMemo } from "react";
import useSWR from "swr";

import { SimpleApplicationsEndpointResponse } from "@application/model/ApplicationJsonModel";

import { applicationEndPoints } from "@api/Endpoints";
import { fetcher } from "@utils/swr-utils";

export function useGetApplications() {
  const url = applicationEndPoints.get();

  const { data, error, isLoading } = useSWR<
    SimpleApplicationsEndpointResponse,
    Error
  >(url, fetcher);

  return useMemo(
    () => ({ applications: data?.applications, isLoading, error }),
    [data, isLoading, error]
  );
}
